import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../../../helpers/Constants';
import {
  DownloadOrderCommentAttachment,
  DownloadOrderCommentAttachmentApiResponse,
} from '../../interfaces';

const downloadOrderCommentAttachment = async ({
  attachmentId,
}: DownloadOrderCommentAttachment) => {
  try {
    const { data } = await axios.get<DownloadOrderCommentAttachmentApiResponse>(
      `/api/commentattachment/${attachmentId}/download`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error?.response?.data?.message);
    } else {
      throw new Error(UNKNOWN_ERROR);
    }
  }
};

export default downloadOrderCommentAttachment;
